import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import { DescriptionField } from "components/support";

export default class CompanyIntegrationsSat extends Component {
  static SoftwareHouseCNPJ = "22769530000131";

  render() {
    const { company } = this.props;

    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Typography type="headline">SAT</Typography>

            <DescriptionField
              fullWidth
              readOnly
              label="CNPJ da PDVend"
              value={CompanyIntegrationsSat.SoftwareHouseCNPJ}
            />

            <DescriptionField
              fullWidth
              readOnly
              label="Código de Associação"
              value={company.fiscal_informations.sat_association_code}
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/sat/index.jsx